import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[qmAutofocus]'
})
export class AutofocusDirective implements OnInit {
  private _qmAutofocus;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    if (this._qmAutofocus || typeof this._qmAutofocus === "undefined") {
      this.el.nativeElement.focus();      //For SSR (server side rendering) this is not safe. Use: https://github.com/angular/angular/issues/15008#issuecomment-285141070)
    }
  }

  @Input() set qmAutofocus(condition: boolean) {
    this._qmAutofocus = condition !== false;
  }
}
